import moment from "moment";
import {
  SIGNIN_INIT,
  SIGNIN_SUCCESS,
  SIGNOUT_SUCCESS,
  SET_BALANCE,
  SET_ACCOUNTS,
} from "../_types";
import { hp } from "../../utils";

const token = hp.getCookie("user_token") || "";
const account = hp.safeParseJSON(hp.getCookie("active_account"), {});

const accountCountry =
  account.organizationCountry || account.country || account.signup_country;

let user = {};

// voice is intentionally open to every account for now
const featureFlags = (acc) => ({
  canAccessVoice: true,
  canAccessMarketPrice: hp.hasFeature(acc, "MARKET_PRICES"),
  canAccessWeather: hp.hasFeature(acc, "WEATHER"),
});

if (hp.getCookie("user")) {
  user = hp.safeParseJSON(hp.getCookie("user"), {});
  user["currency"] =
    user.country || user.signup_country
      ? (user.country || user.signup_country).toLowerCase() === "ghana"
        ? "GHS"
        : "USD"
      : "USD";
  const timeZ = hp.getTimeZone(user.country);
  const timeZone = moment.tz(timeZ).format("Z");
  user["timeZone"] = timeZone;
}
account["currency"] = accountCountry
  ? accountCountry.toLowerCase() === "ghana"
    ? "GHS"
    : "USD"
  : "USD";

const initialState = {
  user,
  account,
  token,
  authenticated: token ? true : false,
  balance: 0,
  signingIn: false,
  accounts: [],
  ...featureFlags(account),
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;

    case SIGNIN_INIT:
      return {
        ...state,
        signingIn: action.payload,
      };

    case SIGNIN_SUCCESS:
      action.payload.data.user["currency"] =
        action.payload.data.user["currency"] || "GHS";
      action.payload.data.account["currency"] =
        action.payload.data.account["currency"] || "GHS";

      return {
        ...state,
        authenticated: true,
        token: action.payload.token,
        user: action.payload.data.user,
        account: action.payload.data.account,
      };

    case SIGNOUT_SUCCESS:
      return {
        ...state,
        user: {},
        token: "",
        authenticated: false,
      };

    case SET_BALANCE:
      return {
        ...state,
        balance: action.payload,
      };

    case SET_ACCOUNTS: {
      const fresh = action.payload.find((row) => row.id === state.account.id);
      if (!fresh) {
        return { ...state, accounts: action.payload };
      }
      const account = { ...state.account, ...fresh };
      return {
        ...state,
        accounts: action.payload,
        account,
        ...featureFlags(account),
      };
    }
  }
};

export default authReducer;
